<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>SINCRONIZACIÓN DE TICKET Y GUIAS DE PLP A ROMANA 2</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione un Rango de Fechas</label>
                            <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                        </div>
                    </div>
                    

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos">Cargar</button>
                    </div>
                </div>


                

                

                <div class="row mt-1">
                    <div class="col">
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered">
                                    <thead class="">
                                        <tr>
                                            
                                            <th class="fixed thead-skyblue2 text-center" v-for="c in columnas" :key="c.label" v-show="c.show">{{c.label}}</th>
                                        </tr>
                                        
                                    </thead>
                                    <tbody>
                                        <tr v-for="d in datos" :key="d.identificador">
                                            <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show">
                                                <span>{{devuelve_valor(d,c.path,c.tipo)}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
                <!-- <pre>{{fechas}}</pre> -->

                
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        todos:true,
        columnas:[
            {show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
            {show:true,label:'Fecha Peso Bruto',tipo:'datetime',path:'fecha_hora_bruto'},
            {show:true,label:'Fecha Peso Tara',tipo:'datetime',path:'fecha_hora_tara'},


            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket'},
            {show:true,label:'Fecha Guía',tipo:'datetime',path:'fecha_guia'},
            {show:true,label:'Materia Prima',tipo:'string',path:'materia_prima'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Peso Bruto (kg)',tipo:'string',path:'peso_vehiculo_bruto'},
            {show:true,label:'Peso Tara (kg)',tipo:'string',path:'peso_vehiculo_tara'},
            {show:true,label:'Peso Neto (kg)',tipo:'string',path:'peso_comercial_neto'},
            {show:true,label:'Peso Corregido (kg)',tipo:'string',path:'peso_comercial_neto_corregido'},

            {show:true,label:'Peso Informado (kg)',tipo:'string',path:'peso_informado'},
            {show:true,label:'Peso Romana (Real Sernapesca) (Kg)',tipo:'string',path:'peso_sernapesca'}

        ],

        
        datos:[],
    }),
    mounted(){
        
    },
    methods:{
        

        async cargar_datos(){
            this.datos = [];
            if(this.fechas[0] != null && this.fechas[0] != undefined){
                await this.axios.get(`${this.api}/sincronizar?desde=${this.fechas[0]}&hasta=${this.fechas[1]}`,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.datos = res.data.data;
                    
                }).catch(e=>{
                    //console.log(e);
                });
            }
            
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        }

        
    },
    computed:{

        ...mapState(['api','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; top: 0; z-index: 100;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>